(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[525],{

/***/ 95008:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/otc",
      function () {
        return __webpack_require__(33108);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ CardTable; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6277);
/* harmony import */ var _CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16962);
/* harmony import */ var _CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var Column = function(_param) {
    var _header = _param.header, header = _header === void 0 ? false : _header, _center = _param.center, center = _center === void 0 ? false : _center, children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "header",
        "center",
        "children",
        "className"
    ]);
    var Element = header ? "th" : "td";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(header ? (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["card-table-header"]) : (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["card-table-column"]), center && (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default().center), className)
    }, props), {
        children: children
    }));
};
var Row = function(_param) {
    var _bold = _param.bold, bold = _bold === void 0 ? false : _bold, _center = _param.center, center = _center === void 0 ? false : _center, children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "bold",
        "center",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["card-table-row"]), bold && (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default().bold), center && (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default().center), className)
    }, props), {
        children: children
    }));
};
var CardTable = function(_param) {
    var headers = _param.headers, children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "headers",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["card-table"]), className)
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, {
                    children: headers.map(function(val, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Column, {
                            header: true,
                            children: val !== "" ? val : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: "\xa0"
                            })
                        }, i + val);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                children: children
            })
        ]
    }));
};

CardTable.Row = Row;
CardTable.Col = Column;


/***/ }),

/***/ 19002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ MediaCarousel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6277);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6917);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76453);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50589);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56050);
/* harmony import */ var _editable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85968);
/* harmony import */ var _sectionLabel__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12219);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84988);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68522);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73314);
/* harmony import */ var _MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7__);












var MediaCard = function(param) {
    var source = param.source, title = param.title, snippet = param.snippet, date = param.date, href = param.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_6__/* .Card */ .Z, {
            className: (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-card"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-source"]), typeof source === "string" && (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["source-text"])),
                    children: source
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-title"]),
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: snippet
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-date"]),
                    children: date
                })
            ]
        })
    });
};
var MediaCarousel = function() {
    var isMobile = (0,react_use__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("(max-width: 55rem)", true);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-carousel"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sectionLabel__WEBPACK_IMPORTED_MODULE_10__/* .SectionLabel */ .e, {
                center: true,
                text: "Media"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
                direction: "horizontal",
                slidesPerView: isMobile ? 1 : 3,
                spaceBetween: 25,
                loop: true,
                modules: isMobile ? [
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Autoplay */ .pt,
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl
                ] : [
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Autoplay */ .pt
                ],
                pagination: isMobile,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                speed: 1000,
                children: _editable__WEBPACK_IMPORTED_MODULE_3__/* .MEDIA_SLIDES.map */ .Qd.map(function(props, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaCard, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props))
                    }, i + props.title);
                })
            })
        ]
    });
};


/***/ }),

/***/ 33108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ otc; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./content/mediaCarousel/MediaCarousel.tsx
var MediaCarousel = __webpack_require__(19002);
// EXTERNAL MODULE: ./content/metaTags/MetaTags.tsx
var MetaTags = __webpack_require__(19055);
// EXTERNAL MODULE: ../../libs/ui/shared/src/lib/pill/Pill.tsx
var Pill = __webpack_require__(1401);
// EXTERNAL MODULE: ./content/otc/otcHero/OTCHero.module.scss
var OTCHero_module = __webpack_require__(49354);
var OTCHero_module_default = /*#__PURE__*/__webpack_require__.n(OTCHero_module);
;// CONCATENATED MODULE: ./content/otc/otcHero/OTCHero.tsx



var OTCHero = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (OTCHero_module_default())["otc-hero"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* Pill */.D, {
                size: "large",
                variation: "blue",
                children: "Donate Over-the-Counter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "OTC Donations"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                children: [
                    "Looking to make a donation to an Endaoment fund \u201COver-the-Counter\u201D?",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please send assets to the corresponding address for your token and fill out an OTC form."
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(6917);
// EXTERNAL MODULE: ../../libs/api/src/lib/api.ts
var api = __webpack_require__(86130);
// EXTERNAL MODULE: ../../libs/ui/icons/src/lib/EthereumIcon.tsx
var EthereumIcon = __webpack_require__(80480);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
;// CONCATENATED MODULE: ../../libs/ui/icons/src/lib/CopyIcon.tsx




var CopyIcon = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 36 : _width, height = _param.height, _strokeColor = _param.strokeColor, strokeColor = _strokeColor === void 0 ? "#53ACDE" : _strokeColor, _strokeWidth = _param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 2 : _strokeWidth, props = (0,_object_without_properties/* default */.Z)(_param, [
        "width",
        "height",
        "strokeColor",
        "strokeWidth"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: width,
        height: height !== null && height !== void 0 ? height : width,
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M20.9 13.2857H17.1C15.4431 13.2857 14.1 14.6289 14.1 16.2857V22.7143M20.9 13.2857H23C24.6569 13.2857 26 14.6289 26 16.2857V24C26 25.6569 24.6569 27 23 27H17.1C15.4431 27 14.1 25.6569 14.1 24V22.7143M20.9 13.2857V11.5714C20.9 10.1513 19.7583 9 18.35 9H11.55C10.1417 9 9 10.1513 9 11.5714V20.1429C9 21.563 10.1417 22.7143 11.55 22.7143H14.1",
            stroke: strokeColor,
            strokeWidth: strokeWidth
        })
    }));
};


// EXTERNAL MODULE: ../../libs/utils/src/lib/formatters.ts
var formatters = __webpack_require__(97022);
// EXTERNAL MODULE: ./content/cardTable/CardTable.tsx
var CardTable = __webpack_require__(57216);
// EXTERNAL MODULE: ../../node_modules/@typeform/embed-react/build/index.js
var build = __webpack_require__(18865);
// EXTERNAL MODULE: ../../node_modules/react-modal/lib/index.js
var lib = __webpack_require__(37149);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ../../libs/ui/shared/src/lib/button/Button.tsx + 1 modules
var Button = __webpack_require__(93636);
// EXTERNAL MODULE: ./content/otc/typeformButton/TypeformButton.module.scss
var TypeformButton_module = __webpack_require__(39999);
var TypeformButton_module_default = /*#__PURE__*/__webpack_require__.n(TypeformButton_module);
;// CONCATENATED MODULE: ./content/otc/typeformButton/TypeformButton.tsx











var ModalOTCInfo = function(param) {
    var logoURI = param.logoURI, name = param.name, symbol = param.symbol, memo = param.memo, address = param.address;
    var isMobile = (0,useMedia/* default */.Z)("(max-width: 40rem)", true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TypeformButton_module_default())["otc-info"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TypeformButton_module_default())["otc-name"],
                children: [
                    logoURI ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: logoURI,
                        alt: name,
                        width: 38,
                        height: 38
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EthereumIcon/* EthereumIcon */.x, {
                        width: 38,
                        height: 38
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            name,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: symbol && " (".concat(symbol.toUpperCase(), ")")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TypeformButton_module_default())["otc-memo"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: isMobile ? "" : (0,formatters/* getShortAddress */.Q5)(address)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyIcon, {
                        onClick: function() {
                            navigator.clipboard.writeText(memo);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TypeformButton_module_default())["otc-address"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: isMobile ? "" : (0,formatters/* getShortAddress */.Q5)(address)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyIcon, {
                        onClick: function() {
                            navigator.clipboard.writeText(address);
                        }
                    })
                ]
            })
        ]
    });
};
var TypeformButton = function(param) {
    var children = param.children, otcAddress = param.otcAddress, className = param.className, small = param.small;
    var ref = (0,react.useState)(false), showForm = ref[0], setShowForm = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                onClick: function() {
                    setShowForm(true);
                },
                className: className,
                size: small ? "small" : "medium",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                className: (TypeformButton_module_default())["typeform-modal"],
                overlayClassName: (TypeformButton_module_default())["modal-overlay"],
                isOpen: showForm,
                onRequestClose: function() {
                    setShowForm(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(build.Widget, {
                        id: "IWxBhuMP",
                        inlineOnMobile: true,
                        className: (TypeformButton_module_default())["typeform-iframe"]
                    }),
                    otcAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOTCInfo, (0,_object_spread/* default */.Z)({}, otcAddress))
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./content/otc/otcSearch/OTCSearch.module.scss
var OTCSearch_module = __webpack_require__(92274);
var OTCSearch_module_default = /*#__PURE__*/__webpack_require__.n(OTCSearch_module);
;// CONCATENATED MODULE: ./content/otc/otcSearch/OTCSearch.tsx













var OTCToken = function(props) {
    var address = props.address, symbol = props.symbol, name = props.name, logoURI = props.logoURI, memo = props.memo;
    var ref = (0,react.useState)(false), showDonate = ref[0], setShowDonate = ref[1];
    var isMobile = (0,useMedia/* default */.Z)("(max-width: 40rem)", true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTable/* CardTable.Row */.c.Row, {
        className: (OTCSearch_module_default())["otc-token"],
        onMouseOver: function() {
            setShowDonate(true);
        },
        onMouseLeave: function() {
            setShowDonate(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTable/* CardTable.Col */.c.Col, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        logoURI ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: logoURI,
                            alt: name,
                            width: 38,
                            height: 38
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EthereumIcon/* EthereumIcon */.x, {
                            width: 38,
                            height: 38
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                name,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: symbol && " (".concat(symbol.toUpperCase(), ")")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeformButton, {
                            className: (0,clsx_m/* default */.Z)((OTCSearch_module_default())["donate-button"], showDonate && (OTCSearch_module_default()).visible),
                            otcAddress: props,
                            small: true,
                            children: "Donate"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTable/* CardTable.Col */.c.Col, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex-row", (OTCSearch_module_default())["copyable-column"]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: isMobile ? "" : (0,formatters/* getShortAddress */.Q5)(address)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyIcon, {
                            onClick: function() {
                                navigator.clipboard.writeText(memo);
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTable/* CardTable.Col */.c.Col, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex-row", (OTCSearch_module_default())["copyable-column"]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: isMobile ? "" : (0,formatters/* getShortAddress */.Q5)(address)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyIcon, {
                            onClick: function() {
                                navigator.clipboard.writeText(address);
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var OTCSearch = function() {
    var ref = (0,es.useQuery)(api/* api.GetOTCAddresses.key */.h.GetOTCAddresses.key, api/* api.GetOTCAddresses.query */.h.GetOTCAddresses.query), otcAddressesData = ref.data;
    // TODO: Move searching to backend
    var ref1 = (0,react.useState)(""), search = ref1[0], setSearch = ref1[1];
    var otcAddresses = (0,react.useMemo)(function() {
        if (otcAddressesData) {
            return otcAddressesData.filter(function(address) {
                return address.name.includes(search);
            });
        }
        return [];
    }, [
        search,
        otcAddressesData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (OTCSearch_module_default())["otc-search-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (OTCSearch_module_default())["otc-search"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        placeholder: "Search addresses, ticker, or token name",
                        value: search,
                        onChange: function(e) {
                            return setSearch(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeformButton, {
                        children: "Start OTC Donation"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTable/* CardTable */.c, {
                headers: [
                    "Token",
                    "Memo*",
                    "Address"
                ],
                children: otcAddresses.map(function(address, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OTCToken, (0,_object_spread/* default */.Z)({}, address), i + address.name);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (OTCSearch_module_default())["otc-footnote"],
                children: [
                    "*Memo is required for the transaction if it is included in the table for that token type.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Questions? Reach out to",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:otc@endaoment.org",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "otc@endaoment.org"
                    }),
                    " ",
                    "for assistance."
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./content/socialLinks/SocialLinks.tsx + 4 modules
var SocialLinks = __webpack_require__(37321);
;// CONCATENATED MODULE: ./pages/otc.tsx





var OTCPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* MetaTags */.N, {
                url: "/otc",
                title: "Endaoment | OTC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OTCHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OTCSearch, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCarousel/* MediaCarousel */.Q, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinks/* SocialLinks */.W, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var otc = (OTCPage);


/***/ }),

/***/ 86130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ api; }
/* harmony export */ });
/* unused harmony export client */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89644);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _endaoment_frontend_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46518);
/* harmony import */ var _endaoment_frontend_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48314);






var client = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
    baseURL: _endaoment_frontend_config__WEBPACK_IMPORTED_MODULE_2__/* .config.apiBaseUrl */ .v.apiBaseUrl,
    withCredentials: true,
    transformRequest: [
        function(data, headers) {
            var token = null;
            if (true) {
                token = window.localStorage.getItem(_endaoment_frontend_constants__WEBPACK_IMPORTED_MODULE_3__/* .TOKEN_STORAGE_KEY */ .MG);
            }
            // eslint-disable-next-line no-param-reassign
            if (token && headers) headers["Authorization"] = "Bearer ".concat(token);
            return data;
        }, 
    ].concat(// @ts-expect-error always array
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((axios__WEBPACK_IMPORTED_MODULE_1___default().defaults.transformRequest)))
});
// Simple error handling for api in dev
if (false) {}
var api = {
    // ************
    // ** Auth
    // ************
    GetAuthToken: {
        key: "GetAuthToken",
        execute: function(input) {
            return client.post("/auth", input);
        }
    },
    // ************
    // ** Me (Auth'd user)
    // ************
    GetMyFunds: {
        key: "GetMyFunds",
        execute: function() {
            return client.get("/me/funds");
        }
    },
    GetMyDonations: {
        key: "GetMyDonations",
        execute: function() {
            return client.get("/me/donations");
        }
    },
    GetMyClaims: {
        key: "GetMyClaims",
        execute: function() {
            return client.get("/me/claims");
        }
    },
    GetMe: {
        key: "GetMe",
        execute: function() {
            return client.get("/me");
        }
    },
    // ************
    // ** Funds
    // ************
    GetFeaturedFunds: {
        key: "GetFeaturedFunds",
        // @TODO: verify this - changes standard for all api calls
        /** @deprecated */ execute: function() {
            return client.get("/funds/public/featured");
        },
        query: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client.get("/funds/public/featured");
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    },
    GetPublicFunds: {
        key: "GetPublicFunds",
        execute: function() {
            return client.get("/funds/public");
        }
    },
    GetFundByVanityUrl: {
        key: "GetFundByVanityUrl",
        execute: function(vanityUrl) {
            return client.get("/funds/vanity/".concat(vanityUrl));
        }
    },
    EstimateFundGas: {
        key: "EstimateFundGas",
        execute: function() {
            return client.get("/funds/estimate");
        }
    },
    CreateFund: {
        key: "CreateFund",
        execute: function(input) {
            return client.post("/funds", input);
        }
    },
    GetFund: {
        key: "GetFund",
        execute: function(id) {
            return client.get("/funds/".concat(id));
        }
    },
    // ************
    // ** Orgs
    // ************
    GetFeaturedOrgs: {
        key: "GetFeaturedOrgs",
        /** @deprecated */ execute: function() {
            return client.get("/orgs/featured");
        },
        query: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client.get("/orgs/featured");
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    },
    GetDeployedOrgs: {
        key: "GetDeployedOrgs",
        /** @deprecated */ execute: function() {
            return client.get("/orgs/deployed");
        },
        query: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client.get("/orgs/deployed");
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    },
    SearchOrgs: {
        key: "SearchOrgs",
        execute: function(searchTerm, code, itemsPerPage, offset) {
            return client.post("/orgs/search", {
                searchTerm: searchTerm,
                code: code,
                itemsPerPage: itemsPerPage,
                offset: offset
            });
        }
    },
    GetOrgByEin: {
        key: "GetOrgByEin",
        /** @deprecated */ execute: function(ein) {
            return client.get("/orgs/".concat(ein));
        },
        query: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ein) {
                var res;
                return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!/^\d{2}-?\d{7}$/.test(ein)) {
                                _ctx.next = 6;
                                break;
                            }
                            _ctx.next = 3;
                            return client.get("/orgs/".concat(ein.replace(/-/g, "")));
                        case 3:
                            res = _ctx.sent;
                            if (!res.data) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return", res.data);
                        case 6:
                            return _ctx.abrupt("return", undefined);
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(ein) {
                return _ref.apply(this, arguments);
            };
        }()
    },
    GetOrgById: {
        key: "GetOrgById",
        execute: function(id) {
            return client.get("/orgs/id/".concat(id));
        }
    },
    EstimateOrgGas: {
        key: "EstimateOrgGas",
        execute: function() {
            return client.get("/orgs/estimate");
        }
    },
    DeployOrg: {
        key: "DeployOrg",
        execute: function(input) {
            return client.post("/orgs", input);
        }
    },
    // ************
    // ** Donations
    // ************
    GetTotalDonations: {
        key: "GetTotalDonations",
        /** @deprecated */ execute: function() {
            return client.get("/donations/total");
        },
        query: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client.get("/donations/total");
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data.totalDonations);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    },
    GetDestinationDonations: {
        key: "GetDestinationDonations",
        execute: function(id) {
            return client.get("/donations/destination/".concat(id));
        }
    },
    GetMinDonation: {
        key: "GetMinDonation",
        execute: function() {
            return client.get("/donations/min");
        }
    },
    CreateDonation: {
        key: "CreateDonation",
        execute: function(input) {
            return client.post("/donations", input);
        }
    },
    // ************
    // ** Grants
    // ************
    GetTotalGrants: {
        key: "GetTotalGrants",
        /** @deprecated */ execute: function() {
            return client.get("/grants/total");
        },
        query: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client.get("/grants/total");
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data.totalGrants);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    },
    GetFundGrants: {
        key: "GetFundGrants",
        execute: function(id) {
            return client.get("/grants/fund/".concat(id));
        }
    },
    GetOrgGrants: {
        key: "GetOrgGrants",
        execute: function(id) {
            return client.get("/grants/org/".concat(id));
        }
    },
    CreateGrant: {
        key: "CreateGrant",
        execute: function(input) {
            return client.post("/grants", input);
        }
    },
    // ************
    // ** Claims
    // ************
    CreateClaim: {
        key: "CreateClaim",
        execute: function(input) {
            return client.post("/claims", input);
        }
    },
    // ************
    // ** Tokens & Swap Info
    // ************
    GetTokens: {
        key: "GetTokens",
        execute: function(chainId) {
            return client.get("/tokens?chainId=".concat(chainId));
        }
    },
    GetSwapInfo: {
        key: "GetSwapInfo",
        execute: function(token, amount) {
            return client.get("/swap-info?amount=".concat(amount.toString()).concat(token.address ? "&tokenAddress=".concat(token.address) : ""));
        }
    },
    // ************
    // ** OTC Tokens & Info
    // ************
    GetOTCAddresses: {
        key: "GetOTCAddresses",
        /** @deprecated */ execute: function() {
            return client.get("/tokens/otc");
        },
        query: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client.get("/tokens/otc");
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    },
    // ************
    // ** ADMIN
    // ** @TODO: API currently doesn't have all admin routes inside /admin - so routes here can be intentionally missing /admin
    // ************
    AdminGetAllFunds: {
        key: "AdminGetAllFunds",
        execute: function() {
            return client.get("/admin/funds");
        }
    },
    AdminGetAllGrants: {
        key: "AdminGetAllGrants",
        execute: function() {
            return client.get("/admin/grants");
        }
    },
    AdminGetAllDonations: {
        key: "AdminGetAllDonations",
        execute: function() {
            return client.get("/admin/donations");
        }
    },
    AdminGetAllWithdrawals: {
        key: "AdminGetAllWithdrawals",
        execute: function() {
            return client.get("/admin/withdrawals");
        }
    },
    AdminGetAllClaims: {
        key: "AdminGetAllClaims",
        execute: function() {
            return client.get("/admin/claims");
        }
    },
    AdminDeployOrgs: {
        key: "AdminDeployOrgs",
        execute: function(input) {
            return client.post("/orgs/deployer", input);
        }
    },
    AdminApproveGrant: {
        key: "AdminApproveGrant",
        execute: function(input) {
            return client.patch("/grants/".concat(input.grantId, "/approve"), input);
        }
    },
    AdminRejectGrant: {
        key: "AdminRejectGrant",
        execute: function(input) {
            return client.patch("/grants/".concat(input.grantId, "/reject"), input);
        }
    },
    AdminApproveClaim: {
        key: "AdminApproveClaim",
        execute: function(id, input) {
            return client.patch("/claims/".concat(id, "/approve"), input);
        }
    },
    AdminRejectClaim: {
        key: "AdminRejectClaim",
        execute: function(id, input) {
            return client.patch("/claims/".concat(id, "/reject"), input);
        }
    },
    AdminClaimOrg: {
        key: "AdminClaimOrg",
        execute: function(id, input) {
            return client.patch("/orgs/".concat(id), input);
        }
    },
    AdminPayout: {
        key: "AdminPayout",
        execute: function(input) {
            return client.post("/withdrawals", input);
        }
    },
    AdminRequestEmail: {
        key: "AdminRequestEmail",
        execute: function(input) {
            return client.get("/admin/email", {
                params: input
            });
        }
    },
    AdminSendEmail: {
        key: "AdminSendEmail",
        execute: function(input) {
            return client.post("/admin/email/direct", input);
        }
    },
    AdminVerifyBank: {
        key: "AdminVerifyBank",
        execute: function(id) {
            return client.get("/claims/verifyBank/".concat(id));
        }
    }
};


/***/ }),

/***/ 97022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dl": function() { return /* binding */ getFormattedEIN; },
/* harmony export */   "Q5": function() { return /* binding */ getShortAddress; },
/* harmony export */   "Sy": function() { return /* binding */ getFormattedMoney; },
/* harmony export */   "_3": function() { return /* binding */ getDate; },
/* harmony export */   "bj": function() { return /* binding */ getFormattedNumber; },
/* harmony export */   "dW": function() { return /* binding */ parseHtml; }
/* harmony export */ });
/* unused harmony exports getCurrency, getNormalizedEIN, getOrgComplianceError */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50930);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86741);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24330);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_1__);



// eslint-disable-next-line no-restricted-imports



var getCurrency = function(value) {
    var fraction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, compact = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        notation: compact ? "compact" : undefined,
        maximumFractionDigits: fraction,
        minimumFractionDigits: fraction
    });
    return formatter.format(Number(value || 0));
};
var getFormattedMoney = function(num) {
    return getCurrency(num, undefined, true).toLowerCase();
};
var numberFormatter = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
    notation: "compact"
});
var getFormattedNumber = function(num) {
    return numberFormatter.format(num).toLowerCase();
};
var dateFormatter = new Intl.DateTimeFormat("en-US", {
    dateStyle: "long"
});
var getDate = function(dateStr) {
    return dateFormatter.format(new Date(dateStr));
};
var getShortAddress = function(address) {
    return address.length > 6 ? "".concat(address.slice(0, 5), "...").concat(address.slice(-3)) : address;
};
var getFormattedEIN = function(ein) {
    return "".concat(ein.slice(0, 2), "-").concat(ein.slice(2));
};
var getNormalizedEIN = function(ein) {
    return (ein || "").replace(/\D/gi, "");
};
/**
 * @param errorsString Error list spaced by ' :: ' between errors
 * @returns The first or only error extracted from `errorsString`
 * @TODO: this should be an array of errors
 */ var getOrgComplianceError = function(errorsString) {
    if (!errorsString) return "";
    var errors = errorsString.split(" :: ");
    return ORG_COMPLIANCE_ERRORS[errors[0]];
};
var parseHtml = function(html) {
    return (0,html_react_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(sanitize_html__WEBPACK_IMPORTED_MODULE_1___default()(html || "", {
        allowedTags: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((sanitize_html__WEBPACK_IMPORTED_MODULE_1___default().defaults.allowedTags)).concat([
            "img"
        ]),
        allowedAttributes: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (sanitize_html__WEBPACK_IMPORTED_MODULE_1___default().defaults.allowedAttributes)), {
            img: [
                "src",
                "alt",
                "style"
            ],
            h3: [
                "style"
            ],
            p: [
                "style"
            ],
            strong: [
                "style"
            ],
            small: [
                "style"
            ]
        })
    }));
};


/***/ }),

/***/ 16962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-table":"CardTable_card-table__u7RX_","card-table-header":"CardTable_card-table-header__AiiU1","card-table-column":"CardTable_card-table-column__lkwX9","center":"CardTable_center__JREo_","card-table-row":"CardTable_card-table-row__UVtds","bold":"CardTable_bold__hxBli","slide":"CardTable_slide__kiOUb","dash":"CardTable_dash__PAmP3","spin":"CardTable_spin__hGjxu","rotate":"CardTable_rotate__nu7cf","floating":"CardTable_floating__hLQHD"};

/***/ }),

/***/ 73314:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"media-carousel":"MediaCarousel_media-carousel__KqPYx","media-card":"MediaCarousel_media-card__HA87Y","spin":"MediaCarousel_spin__stzby","media-source":"MediaCarousel_media-source__2hdPY","source-text":"MediaCarousel_source-text___aRQ9","media-title":"MediaCarousel_media-title__YJ6Rd","media-date":"MediaCarousel_media-date__0iIDS","slide":"MediaCarousel_slide__qcXF2","dash":"MediaCarousel_dash__2lSjm","rotate":"MediaCarousel_rotate__TtR36","floating":"MediaCarousel_floating__nkc8T"};

/***/ }),

/***/ 49354:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"otc-hero":"OTCHero_otc-hero__fJBRI","slide":"OTCHero_slide__i7SLb","dash":"OTCHero_dash__YQIzc","spin":"OTCHero_spin__KMF6g","rotate":"OTCHero_rotate__vrNJe","floating":"OTCHero_floating__NR_0k"};

/***/ }),

/***/ 92274:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"otc-search-container":"OTCSearch_otc-search-container__VVc3p","otc-search":"OTCSearch_otc-search__AOf0h","copyable-column":"OTCSearch_copyable-column__AlEkb","otc-footnote":"OTCSearch_otc-footnote__buEG4","donate-button":"OTCSearch_donate-button__P7oB_","visible":"OTCSearch_visible___KyaH","slide":"OTCSearch_slide__1YYpO","dash":"OTCSearch_dash__l9KBN","spin":"OTCSearch_spin__Qz5mW","rotate":"OTCSearch_rotate__1K51N","floating":"OTCSearch_floating__c0id_"};

/***/ }),

/***/ 39999:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"typeform-modal":"TypeformButton_typeform-modal__pgmuI","typeform-iframe":"TypeformButton_typeform-iframe__DHup0","otc-info":"TypeformButton_otc-info__LZsPy","otc-name":"TypeformButton_otc-name__IcU5V","otc-memo":"TypeformButton_otc-memo__Y6MQZ","otc-address":"TypeformButton_otc-address__dhNac","modal-overlay":"TypeformButton_modal-overlay__iLRgo","slide":"TypeformButton_slide__jssqm","dash":"TypeformButton_dash__A3gYf","spin":"TypeformButton_spin__It4Xt","rotate":"TypeformButton_rotate__I_NFU","floating":"TypeformButton_floating__joXUo"};

/***/ }),

/***/ 70764:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 45158:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 58635:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 30139:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [652,602,577,282,749,253,389,774,888,179], function() { return __webpack_exec__(95008); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);